import moment from "moment";

const lpOpenTradeColumns = (page = 1, pageSize = 10) => [
  {
    title: "No.",
    key: "no",
    render: (_, __, index) => (page - 1) * pageSize + index + 1,
  },
  {
    title: "Login",
    dataIndex: "login",
  },
  {
    title: "Position Id",
    dataIndex: "positionId",
  },
  {
    title: "Symbol",
    dataIndex: "symbol",
  },
  {
    title: "Type",
    dataIndex: "type",
    render: (text) => text === 'BUY' ? <span className="text-[#28C76F] bg-[#DDF6E8] p-1 px-2 rounded font-semibold" >Buy</span> : <span className="text-[#FF4C51] bg-[#FFE2E3] p-1 px-2 rounded font-semibold" >Sell</span>,
  },
  {
    title: "Volume",
    dataIndex: "volume",
  },
  {
    title: "Open Price",
    dataIndex: "priceOpen",
    render: (text) => text ? `$ ${typeof text === 'number' ? text.toFixed(5) : text}` : '',
  },
  {
    title: "Current Price",
    dataIndex: "priceCurrent",
    render: (text) => text ? `$ ${typeof text === 'number' ? text.toFixed(5) : text}` : '',
  },
  {
    title: 'S/L',
    dataIndex: 'stopLoss',
    render: (text) => text ? `$ ${text}` : '--',
  },
  {
    title: 'T/P',
    dataIndex: 'takeProfit',
    render: (text) =>  text ? `$ ${text}` : '--',
  },
  {
    title: 'Swap',
    dataIndex: 'swap',
    render: (text) =>  text ? `$ ${text}` : '--',
  },
  {
    title: 'Open Time',
    dataIndex: 'time',
    render: (text) => text ? moment(text).format('DD-MM-YYYY h:mm A') : '--',
  },
  {
    title: 'P/L',
    dataIndex: 'profit',
    render: (text) => text > 0 ? <span className="text-[#28C76F] font-semibold">$ {text}</span> : <span className="text-[#FF4C51] font-semibold">$ {text}</span>,
    width: 120,
  },
];

export default lpOpenTradeColumns;
